//#region import
import React, { Fragment, useEffect, useState } from 'react';
import { Avatar, Box, Card, Divider, Grid, Typography } from '@mui/material';
import CardFrom from 'components/CardContent/CardFrom';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';

import DefaultAvatar from "assets/images/NoImage/default-avatar.png";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import CallIcon from '@mui/icons-material/Call';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { ApiLeave } from 'enum/api';
import { APIStatusCode, EnumLeaveTypeID, EnumLogHistoryMode, EnumModeProfiles } from 'enum/enum';

import AccordionCustom from "components/Accordion";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
//#endregion

export interface IPropsProfiles{
    nUserID: number;
    nYear?: number;
    nMode: EnumModeProfiles;
}

const Profiles = (props: IPropsProfiles) => {
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    //#region Profiles
    const [ObjData, setObjData] = useState(null);
    const [sImageUser, setsImageUser] = useState(null);
    //#endregion

    //#region Leave
    //ประเภทการลา (Sick > ลาป่วย || Vacation > ลาพักผ่อน)
    const [ObjDetails_Sick, setObjDetails_Sick] = useState(null); 
    const [ObjDetails_Vacation, setObjDetails_Vacation] = useState(null);
    //#endregion

    //#region Time
    const [sWorkingTime, setWorkingTime] = useState("00:00");
    const [sLateCollect, setLateCollect] = useState("00:00");
    const [sWorkingDays, setWorkingDays] = useState(0);
    //#endregion

    useEffect(() => {
        if(props.nUserID) GetProfiles(props.nUserID);
    }, [props.nUserID]);

    const GetProfiles = (_nUserID) => {
        let objParam = {
            nUserID: _nUserID,
            nModeID: props.nMode,
        };
        AxiosFn.Get(ApiLeave.GetProfiles, objParam, (result) => {
            if (result.nStatusCode === APIStatusCode.Success) 
            {
                setObjData({
                    nUserID: result.nUserID,
                    sUserName: result.sUserName,
                    sUserImg: result.sUserImg,
                    nJobID: result.nJobID,
                    sJobName: result.sJobName,
                    nOrganizationID: result.nOrganizationID,
                    sOrganization: result.sOrganization,
                    nUserTypeID: result.nUserTypeID,
                    sUserType: result.sUserType,
                    dWorkStart: result.dWorkStart,
                    sWorkStartDate: result.sWorkStartDate,
                    sEmail: result.sEmail,
                    sTelNo: result.sTelNo,    
                });            
                setsImageUser(result.sUserImg);
                if(props.nMode === EnumModeProfiles.Leave)
                {
                    let ObjSick = result.lstDetailsLeave.filter(f => f.nLeaveTypeID === EnumLeaveTypeID.SickLeave);
                    setObjDetails_Sick((ObjSick ?? []).length > 0 ? ObjSick[0] : []); //ลาป่วย
                    let ObjVacation = result.lstDetailsLeave.filter(f => f.nLeaveTypeID === EnumLeaveTypeID.VacationLeave);
                    setObjDetails_Vacation((ObjVacation ?? []).length > 0 ? ObjVacation[0] : []); //ลาพักผ่อน
                }
                else if(props.nMode === EnumModeProfiles.Time)
                {
                    setWorkingTime(result.ObjDetailsTime.sWorkingTime);
                    setLateCollect(result.ObjDetailsTime.sCollectorLate);
                    setWorkingDays(result.ObjDetailsTime.nDaysWorkingAll);
                }
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    }

    const onImageError = (e) => {
        e.target.src = DefaultAvatar;
    }

    return (
        <Grid item container xs={12} md={12} spacing={2} style={{ paddingBottom: '1%', }}>
            <Grid item xs={12} md={8}>
                <CardFrom bgColor='#fbfbfb' minHeightCard='300px'>
                    <Grid item xs={12} md={12} container spacing={1}>
                        <Grid item xs={12} md={12} className='div-Card-Profiles'>
                            <Typography gutterBottom variant="h6">{ObjData?.sUserName}</Typography>                                
                        </Grid>
                        <Grid item xs={12} md={12} container justifyItems={'center'} justifyContent={'center'}>
                            <Grid item xs={12} sm={5} md={4} container justifyItems={'center'} justifyContent={'center'} > {/* className='div-ImgProfiles' */}
                                {sImageUser ? 
                                    <img 
                                        src={sImageUser} 
                                        alt={''} 
                                        className='ImgProfiles'
                                        style={{
                                            width: '80%',
                                            minHeight: '200px',
                                            objectFit: 'cover',
                                            borderRadius: '50%',
                                            background: '#ededed',
                                            // boxShadow: '2px 6px 5px #e3e2e2, -7px -7px 15px #d9d9d9',
                                            boxShadow: 'rgb(227, 226, 226) 2px 6px 5px, rgb(239 235 235) -7px -7px 15px',
                                        }} 
                                        onError={onImageError}
                                    /> 
                                :
                                    <AccountCircleIcon sx={{ fontSize: '220px', color: '#d1d1d1' }} />
                                }                                
                            </Grid>
                            <Grid item xs={12} sm={7} md={8} container style={{ paddingTop: '2%',}}>
                                <Grid item xs={12} md={12} container spacing={1}>
                                    <Grid item md={4}>
                                        <Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sPosition")}`}</Typography>    
                                    </Grid>
                                    <Grid item md={8}>
                                        <Typography variant="body1">{ObjData?.sJobName}</Typography> 
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} container spacing={1}>
                                    <Grid item md={4}>
                                        <Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sAffiliatedAgency")}`}</Typography>           
                                    </Grid>
                                    <Grid item md={8}>
                                        <Typography variant="body1">{ObjData?.sOrganization}</Typography> 
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                    <Grid item md={4}>
                                        <Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sEmployeeType")}`}</Typography>   
                                    </Grid>
                                    <Grid item md={8}>
                                        <Typography variant="body1">{ObjData?.sUserType}</Typography> 
                                    </Grid>
                                </Grid>                                
                                <Grid item xs={12} md={12} container spacing={1} style={{ backgroundColor: '#f1f5f9', borderRadius: '20px',}}>
                                    <Grid item xs={12} md={12} container>
                                        <Grid item md={4}>
                                            <Typography gutterBottom variant="body1" fontWeight="bold">{`${I18n.SetText("Leave.sWorkStartDate")}`}</Typography>  
                                        </Grid>
                                        <Grid item md={8}>
                                            <Typography variant="body1">{ObjData?.sWorkStartDate}</Typography> 
                                        </Grid>
                                    </Grid> 
                                    <Grid item xs={12} md={7} container spacing={2}>
                                        <Grid item><MailIcon sx={{ fontSize: '30px', color: '#dfad15' }} /></Grid>
                                        <Grid item><Typography gutterBottom variant="body1">{ObjData?.sEmail}</Typography></Grid>
                                    </Grid>
                                    <Grid item xs={12} md={5} container spacing={2}>
                                        <Grid item><CallIcon sx={{ fontSize: '30px', color: '#dfad15' }} /></Grid>
                                        <Grid item><Typography gutterBottom variant="body1">{ObjData?.sTelNo ? ObjData?.sTelNo : "-"}</Typography></Grid>                             
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardFrom>
            </Grid>
            { props.nMode === EnumModeProfiles.Leave ?
                <Grid item xs={12} md={4} container spacing={2}>
                    <Grid item xs={12} md={12} container justifyItems={'end'} justifyContent={'end'}>
                        <Typography gutterBottom variant="body1" color={'#790103'}>{`${I18n.SetText("Leave.sAnnual")}` + " " + (props.nYear ?? (+new Date().getFullYear + 543))}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                        <CardFrom bgColor='#d7f6f9' minHeightCard='120px'>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} sm={5} md={3} container justifyItems={'center'} justifyContent={'center'} style={{ textAlign: 'center'}}>
                                    <Grid item xs={12} md={7}> {/* style={{ backgroundColor: 'white', borderRadius: '50%', height: '54%', width: '50%',}} */}
                                        <MedicalServicesIcon sx={{ fontSize: '40px', color: '#5598fc', marginTop: '10%', }} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography gutterBottom variant="h6" component="div" style={{ color: '#5598fc', fontSize: 'large'}}>{`${I18n.SetText("Leave.sSickLeave")}`}</Typography>
                                    </Grid>    
                                </Grid>
                                <Grid item xs={12} sm={7} md={9} container justifyItems={'flex-start'} justifyContent={'center'}>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item md={7}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sLeave")}`}</Typography></Grid>  
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="#f05454" fontWeight="bold">{ObjDetails_Sick?.nLeave}</Typography></Grid>
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sDay")}`}</Typography></Grid>                         
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item md={7}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sLeaveRemain")}`}</Typography></Grid>  
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="#d9c72e" fontWeight="bold">{ObjDetails_Sick?.nLeaveRemain}</Typography></Grid>
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sDay")}`}</Typography></Grid>                         
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item md={7}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sLeaveAll")}`}</Typography></Grid>  
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="#1fd61c" fontWeight="bold">{ObjDetails_Sick?.nLeaveAll}</Typography></Grid>
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sDay")}`}</Typography></Grid>                         
                                    </Grid>
                                </Grid>
                            </Grid>                        
                        </CardFrom>
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                        <CardFrom bgColor='#feefe9' minHeightCard='120px'>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item xs={12} sm={5} md={3} container justifyItems={'center'} justifyContent={'center'} style={{ textAlign: 'center'}}>
                                    <Grid item xs={12} md={7}> {/* style={{ backgroundColor: 'white', borderRadius: '50%', height: '50%', width: '50%',}} */}
                                        <PhotoCameraIcon sx={{ fontSize: '40px', color: '#f8a746', marginTop: '10%', }} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography gutterBottom variant="h6" component="div" style={{ color: '#f8a746', fontSize: 'large'}}>{`${I18n.SetText("Leave.sVacationLeave")}`}</Typography>
                                    </Grid>    
                                </Grid>
                                <Grid item xs={12} sm={7} md={9} justifyItems={'flex-start'} justifyContent={'center'}>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item md={7}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sLeave")}`}</Typography></Grid>  
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="#f05454" fontWeight="bold">{ObjDetails_Vacation?.nLeave}</Typography></Grid>
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sDay")}`}</Typography></Grid>                         
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item md={7}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sLeaveRemain")}`}</Typography></Grid>  
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="#d9c72e" fontWeight="bold">{ObjDetails_Vacation?.nLeaveRemain}</Typography></Grid>
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sDay")}`}</Typography></Grid>                         
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1}>
                                        <Grid item md={7}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sLeaveAll")}`}</Typography></Grid>  
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="#1fd61c" fontWeight="bold">{ObjDetails_Vacation?.nLeaveAll}</Typography></Grid>
                                        <Grid item md={2}><Typography gutterBottom variant="body1" color="text.secondary">{`${I18n.SetText("Leave.sDay")}`}</Typography></Grid>                         
                                    </Grid>
                                </Grid>
                            </Grid>           
                        </CardFrom>
                    </Grid>
                </Grid>
                : 
                (props.nMode === EnumModeProfiles.Time ? 
                    <Grid item xs={12} md={4} container spacing={1}>
                        <Grid item xs={12} md={12} container justifyItems={'end'} justifyContent={'end'}>
                            <Typography gutterBottom variant="body1" color={'#790103'}>{`${I18n.SetText("Leave.sAnnual")}` + " " + (props.nYear ?? (+new Date().getFullYear + 543))}</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={2}>
                            <Grid item container xs={12}>
                                <Grid item xs={6}>
                                    <Card
                                        sx={{
                                            textAlign: "center",
                                            bgcolor: "#f6d4b0",
                                            padding: 1,
                                            mt: 0,
                                            ml: 1,
                                            mb: 1,
                                            mr: 0,
                                            borderRadius: "10px",
                                            boxShadow:
                                            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px !important",
                                        }}
                                        >
                                        <AccessTimeIcon sx={{ color: "#da9e85", fontSize: "1.5rem" }} />
                                        <Box sx={{ bgcolor: "#d9b692", borderRadius: "10px" }}>
                                            <Typography sx={{ color: "#790000", fontSize: "1.2rem" }}>
                                            {`${I18n.SetText('TimeAttendance.sWorkingTime')}`}
                                            </Typography>
                                            <Typography sx={{ color: "#790000" }}>({`${I18n.SetText('TimeAttendance.sHour')}`})</Typography>
                                        </Box>
                                        <Typography sx={{ color: "white", fontSize: "1.2rem", mt: 1 }}>
                                            {sWorkingTime}
                                        </Typography>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card
                                        sx={{
                                            textAlign: "center",
                                            bgcolor: "#de675d",
                                            padding: 1,
                                            mt: 0,
                                            ml: 1,
                                            mb: 1,
                                            mr: 0,
                                            borderRadius: "10px",
                                            boxShadow:
                                            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px !important",
                                        }}
                                        >
                                        <ErrorOutlineIcon sx={{ color: "#ecbab5", fontSize: "1.5rem" }} />
                                        <Box sx={{ bgcolor: "#df7b77", borderRadius: "10px" }}>
                                            <Typography sx={{ color: "#790000", fontSize: "1.2rem" }}>
                                            {`${I18n.SetText('TimeAttendance.sCollectLate')}`}
                                            </Typography>
                                            <Typography sx={{ color: "#790000" }}>({`${I18n.SetText('TimeAttendance.sHour')}`})</Typography>
                                        </Box>
                                        <Typography sx={{ color: "white", fontSize: "1.2rem", mt: 1 }}>
                                            {sLateCollect}
                                        </Typography>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Card
                                    sx={{
                                    textAlign: "center",
                                    bgcolor: "#99605a",
                                    padding: 1,
                                    mt: 0,
                                    ml: 1,
                                    mb: 1,
                                    mr: 0,
                                    borderRadius: "10px",
                                    boxShadow:
                                        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px !important",
                                    }}
                                >
                                    <Typography sx={{ color: "white", fontSize: "1.5rem" }}>
                                    {`${I18n.SetText('TimeAttendance.sSumWorkingDay')}`} ({`${I18n.SetText('TimeAttendance.sDay')}`})
                                    </Typography>
                                    <Typography sx={{ color: "white", fontSize: "1.5rem", mt: 1 }}>
                                    {sWorkingDays}
                                    </Typography>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                :
                <></>
                )
            }
        </Grid>
    )
}
export default Profiles;
